import React, { useEffect, useState } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { useHistory } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Stack, Typography, Box } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import CartSelector from 'components/CartSelector';
import DeletedOrdersTable from './DeletedOrdersTable';
import utils from 'components/utils';

const DeletedOrders = props => {
	const theme = useTheme();
	const translate = utils.useI18N();
	const history = useHistory();
	const realUser = useStoreState(state => state.me.data);
	const items = useStoreState(state => state.cart.deleted.items);
	const cartList = useStoreState(state => state.cart.listLight.items);
	const loadingCreateOrder = useStoreState(state => state.order.createMultiple.loading);
	const createOrder = useStoreActions(dispatch => dispatch.order.createMultiple.sendRequest);
	const itemSelected = items.filter(i => i.isSelected);

	const addToCart = _ => {
		const cart = cartList.find(item => item.selected);
		const cartId = cart ? cart.id : null;
		const total = itemSelected.map(item => item.price * item.quantityRequiredNew).reduce((a, b) => a + b, 0);
		const orders = itemSelected.map(item => {
			const order = {
				catalog: item.catalog,
				depot: item.depotNew,
				cartId,
				quantity: item.quantityRequiredNew,
				promoCode: null,
				realUserCode: realUser.id,
				totalPrice: total,
				sla: null,
				supplier: null,
				shippingType: null
			};

			return order;
		});
		const successMessage = translate('catalog.selection.addToSelectedCart') + ' ' + cart.name;
		createOrder({
			orders,
			successMessage,
			history,
			fcd: false,
			redirect: '/orders/list'
		});
	};

	return (
		<Stack
			direction="column"
			justifyContent="flex-start"
			alignItems="flex-start"
			spacing={0.5}
			variant="wrapperSection"
			sx={{ padding: { xs: '20px 5px', md: '20px', sm: '20px 10px' } }}
		>
			<Typography variant="titleTab" sx={{ color: theme.palette.secondary.main }}>
				{translate('orders.deletedItemsWarning')}
			</Typography>
			<Stack
				direction={{ xs: 'column-reverse', md: 'row', sm: 'row' }}
				justifyContent={{ xs: 'flex-start', md: 'space-between', sm: 'space-between' }}
				alignItems={{ xs: 'flex-start', md: 'center', sm: 'center' }}
				spacing={{ xs: 1, md: 0, sm: 0 }}
				sx={{
					width: '100%',
					height: { xs: itemSelected.length == 0 ? '30px' : '70px', md: '50px', sm: '50px' }
				}}
			>
				<Typography variant="titleSection">{translate('orders.deletedItems')}</Typography>
				<Stack
					direction="row"
					justifyContent="flex-start"
					alignItems="center"
					spacing={0.5}
					sx={{
						maxWidth: { xs: '100%', md: '350px', sm: '350px' },
						display: itemSelected.length == 0 ? 'none' : 'inherit'
					}}
				>
					<CartSelector />
					<LoadingButton
						variant="dark"
						endIcon={<AddShoppingCartIcon />}
						loading={loadingCreateOrder}
						loadingPosition="end"
						onClick={addToCart}
						sx={{ width: '240px' }}
					>
						{translate('orders.newOrder')}
					</LoadingButton>
				</Stack>
			</Stack>
			<Box sx={{ width: '100%', marginTop: '10px !important' }}>
				<DeletedOrdersTable />
			</Box>
		</Stack>
	);
};

export default DeletedOrders;
